import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout")({
    component: ToolStructureLayout,
    loader: ({ context: { t } }) => ({
        breadcrumb: t("pages.tool.design.title"),
    }),
});

function ToolStructureLayout() {
    return <Outlet />;
}
